import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import SituationTile from './SituationTile';
import { useInkindSituations } from '@gik/marketing/api/wp/situation';
import withSuspense from '@gik/core/components/suspended/withSuspense';
import { LoadingSpinner } from '@gik/ui';

export const SituationsOverviewGridBlockName = 'situations-overview-grid';

export interface ISituation {
  id: string;
  imageUrl: string;
}

export interface SituationsOverviewGridProps extends React.HTMLProps<HTMLDivElement> {}

function SituationsOverviewGrid({ className }: SituationsOverviewGridProps): React.ReactElement {
  const bem = bemBlock(SituationsOverviewGridBlockName);

  const { data: situations, error: situationsError } = useInkindSituations(1, 100);

  const isLoading = !situations;
  const isError = isLoading && situationsError;

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <LoadingSpinner />;

  if (situations?.length === 0) {
    return <div className={bem('empty')}>No situations found.</div>;
  }

  return (
    <div className={bem(null, null, [className, 'gik-flex-grid'])}>
      {situations.map(situation => {
        return (
          <SituationTile key={situation.id} title={situation.name} imageUrl={situation.acf.taxonomy_svg_icon_alt} />
        );
      })}
    </div>
  );
}

export default withSuspense(SituationsOverviewGrid);
